import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 *
 * @param {
 * HK_VEH_REGISTRATION_TYPE,
 * HK_VEH_REGISTRATION_ID_TYPE,
 * COLOR,
 * VEH_DRIVER_SET,
 * } baseParameterType
 * @returns
 */
const getBaseParameter = (baseParameterType) => {
  return axios
    .get(`${basePath}/protected/api/v1/base-parameter`, { params: { baseParameterType } })
    .then((res) => res.data);
};

export default {
  getBaseParameter,
};
